import axios from './axiosInstance';
import { APIRedirect } from '../../types';

interface GetRedirectsParams {
  sport: string;
  areaId: string;
}

const getRedirects = ({ sport, areaId }: GetRedirectsParams): Promise<APIRedirect[] | void> => {
  let url = `/${sport}/areas/${areaId}/redirects`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const bundledFunctions = {
  getRedirects,
};

export default bundledFunctions;
